import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/core/services/store";
// import ApiService from "@/core/services/api.service";
// import MockService from "@/core/mock/mock.service";
import { GET_PROFILE } from "@/core/services/store/auth.module";
import { RESET_LAYOUT_CONFIG } from "@/core/services/store/config.module";
import "vue-easytable/libs/theme-default/index.css";
import VueEasytable from "vue-easytable";

Vue.config.productionTip = false;

// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
window.PerfectScrollbar = PerfectScrollbar;
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;
import VueClipboard from "vue-clipboard2";
VueClipboard.config.autoSetContainer = true; // add this line

Vue.use(VueClipboard);
// Vue 3rd party plugins
import * as VueGoogleMaps from "vue2-google-maps";
import i18n from "@/core/plugins/vue-i18n";
import vuetify from "@/core/plugins/vuetify";
import VueSlider from "vue-slider-component";
import SearchSelect from "@/components/SearchSelect.vue";
import Vuelidate from "vuelidate";
import "vue-slider-component/theme/default.css";
import "@/core/plugins/portal-vue";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/perfect-scrollbar";
import "@/core/plugins/highlight-js";
import "@/core/plugins/inline-svg";
import "@/core/plugins/apexcharts";
import "@/core/plugins/treeselect";
import "@/core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";
import "@/core/plugins/formvalidation";
import axios from "axios";
Vue.prototype.$axios = axios;
import interceptorsSetup from "@/plugin/axios";

// API service init
// ApiService.init();

// // Remove this to disable mock API
// MockService.init();

router.beforeEach((to, from, next) => {
  // Ensure we checked auth before each page load.
  Promise.all([store.dispatch(GET_PROFILE)])
    .then(() => {
      // Check if user is authenticated for protected routes
      if (to.name !== "login" && !store.getters.isAuthenticated) {
        // If not authenticated and trying to access protected route, redirect to login
        next({ name: "login" });
      } else {
        next();
      }
    })
    .catch(() => {
      // If there's an error (like token expired), redirect to login
      if (to.name !== "login") {
        next({ name: "login" });
      } else {
        next();
      }
    });

  // reset config to initial state
  store.dispatch(RESET_LAYOUT_CONFIG);

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

Vue.component("VueSlider", VueSlider);
Vue.component("SearchSelect", SearchSelect);
Vue.use(Vuelidate);
Vue.use(interceptorsSetup);
Vue.use(VueEasytable);
Vue.use(VueGoogleMaps, {
  load: {
    // key: "AIzaSyBqNgUH2b3f59YJkPHtInk7sRiwJw1FQck",
    key: process.env.VUE_APP_GMAPS_KEY,
    libraries: "places",
    region: "ID",
    language: "id",
  },
});
new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
